import merge from 'lodash/merge';
import { palette } from './palette';

const sharedConfig = {
    fontFamily: ['Roboto', '-apple-system', 'BlinkMacSystemFont', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
    lineHeight: 1.5,
};

export const typography = merge(createSharedConfig(sharedConfig), {
    allVariants: {
        color: palette.text?.primary,
    },
    h1: {
        fontSize: 32,
        lineHeight: '40px',
        fontWeight: 700,
    },
    h2: {
        fontSize: 24,
        lineHeight: '32px',
        fontWeight: 700,
    },
    h3: {
        fontSize: 20,
        lineHeight: '24px',
        fontWeight: 700,
    },
    subtitle1: {
        fontSize: 32,
        lineHeight: '40px',
        fontWeight: 500,
    },
    subtitle2: {
        fontSize: 20,
        lineHeight: '24px',
        fontWeight: 500,
    },
    subtitle3: {
        fontSize: 16,
        lineHeight: '24px',
        fontWeight: 500,
        color: palette.text?.primary,
    },
    subtitle4: {
        fontSize: 14,
        lineHeight: '16px',
        fontWeight: 500,
        color: palette.text?.primary,
    },
    subtitle5: {
        fontSize: 12,
        lineHeight: '14px',
        fontWeight: 500,
        color: palette.text?.primary,
    },
    body1: {
        fontSize: 16,
        lineHeight: '24px',
        letterSpacing: 'unset',
    },
    body2: {
        fontSize: 14,
        lineHeight: '16px',
    },
    body3: {
        fontSize: 12,
        lineHeight: '14px',
        fontWeight: 400,
    },
});

export function createSharedConfig(sharedConfig: object) {
    return {
        ...sharedConfig,
        button: { ...sharedConfig },
        h1: { ...sharedConfig },
        h2: { ...sharedConfig },
        h3: { ...sharedConfig },
        subtitle1: { ...sharedConfig },
        subtitle2: { ...sharedConfig },
        subtitle3: { ...sharedConfig },
        subtitle4: { ...sharedConfig },
        body1: { ...sharedConfig },
        body2: { ...sharedConfig },
        body3: { ...sharedConfig },
    };
}
